// extracted by mini-css-extract-plugin
export default {"card":"Login_card__zwf2i","submitBtnContainer":"Login_submitBtnContainer__6TqOQ","loginTableContainer":"Login_loginTableContainer__EDPQA"};